.pendingComment {
  margin: 1rem 0;
  padding: 1rem;
  border: 1px solid var(--color-muted);
  border-radius: 8px;
}

.pendingContent {
  margin: 0;
  font-family: var(--font-family-base);
  animation: pulse 1.5s ease-in-out infinite;
}

.pendingMeta {
  align-items: center;
  display: flex;
  font-family: var(--font-family-base);
  gap: 0.5rem;
  justify-content: flex-end;
  margin: 0.5rem 0 0;
  opacity: 0.7;
}

.pendingAiImage {
  height: 48px;
  width: 48px;
  border-radius: 50%;
  object-fit: cover;
}

.errorComment {
  margin: 1rem 0;
  padding: 1rem;
  border: 1px solid var(--color-danger, #c53030);
  border-radius: 8px;
  color: var(--color-danger, #c53030);
  font-family: var(--font-family-base);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
}

.content {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 2rem;
  margin: 0 2rem 2rem;
}

.copy p {
  margin: 1rem 0;
}

.aiDisclosure {
  font-size: 0.85rem;
  opacity: 0.7;
}

.portraits {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}

.image {
  width: 10rem;
  height: 10rem;
  border: 2px solid var(--color-text);
  border-radius: 50%;
  object-fit: cover;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin: 0 2rem 1rem;
}

@media (max-width: 48rem) {
  .content {
    grid-template-columns: 1fr;
    margin-inline: 1rem;
  }

  .portraits {
    justify-self: center;
  }

  .image {
    width: 5rem;
    height: 5rem;
  }

  .actions {
    margin-inline: 1rem;
    flex-wrap: wrap;
  }
}
